import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import {ReportContextProvider} from '../../../contexts/ReportContext';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {
  PageMainTitle,
  SubInner,
  InputLabel,
  FormTextArea,
  RequiredLabel,
  FormInput,
} from '../../atoms/CommonParts';

const Page = styled.div`

  .bignav-link {
    display: flex;
    text-decoration: none;
    color: #000000;
    padding-left: 5px;
    justify-content: space-between;
    position: relative;
    border-bottom: 1px solid #000000;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 20px;
    gap: 15px;

    span {
      font-size: 32px;
      line-height: 43px;
      font-weight: bold;
      display: inline-block;
      flex: 1 1 auto;
    }

    @media ${config.layout.wide} {
      &:hover {
        &::after {
          margin-right: 0;
        }
      }
    }

    &::after {
      content: "";
      flex: 0 0 auto;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11.375' height='19.719' viewBox='0 0 11.375 19.719'%3E%3Cpath id='パス_44' data-name='パス 44' d='M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
      display: block;
      width: 12px;
      height: 20px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-right: 15px;
      transition: margin 0.15s ease-out;
    }
  }
`;


const SingleColumnLink = styled.div`
  border-top: 1px solid #000000;
`;

const MultiColumnLink = styled.div`
  @media ${config.layout.wide} {
    display: flex;
    gap: 40px;
  }

  .bignav-link {
    @media ${config.layout.wide} {
      width: calc(50% - 20px);
    }
  }
`;

export default function ManualPage() {
  const app = useApp();

  useEffect(() => {
    app.showHeader();
    document.title = 'Manual';
  }, []);

  return (
      <Page>
        <PageMainTitle style={{
          'margin-bottom': 80
        }}><span>Manual</span></PageMainTitle>

        <SingleColumnLink>
          <Link to="/manual/how-to-register/" className="bignav-link">
            <span>How to register your device</span>
          </Link>
        </SingleColumnLink>
        <MultiColumnLink>
          <a href={'https://kuvo.com/venue/setup-guide'}
             className="bignav-link" target={'_blank'}>
            <span>Setup guide</span>
          </a>
          <a href={'https://www.pioneerdj.com/en/product/player/cdj-3000/black/support/'}
             className="bignav-link" target={'_blank'}>
            <span>FW Download</span>
          </a>
        </MultiColumnLink>

        <MultiColumnLink>
          <Link to="/faq/" className="bignav-link">
            <span>FAQ</span>
          </Link>
          <Link to="/contact/" className="bignav-link">
            <span>Contact</span>
          </Link>
        </MultiColumnLink>
      </Page>
  );
}